var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainLogoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95.942,
    height: 23.603,
    viewBox: "0 0 95.942 23.603",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-sl",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcea10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-sl-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcea10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-sl-3",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-sl"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    transform: "translate(-0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M7.458,48.482a2.24,2.24,0,0,0-.553,1.972c.154.914,1.489,1.58,2.726,1.929.411.116.856.2,1.328.293.28.053.568.109.861.174a8.772,8.772,0,0,1,2.757,1.025A2.884,2.884,0,0,0,15.894,53a1.708,1.708,0,0,0,.51-1.56c-.169-.868-1.57-1.611-2.807-1.961-.52-.139-.916-.217-1.373-.3-.245-.048-.5-.1-.813-.162A7.981,7.981,0,0,1,8.354,47.79a2.668,2.668,0,0,0-.9.694Z",
    transform: "translate(-5.13 -35.726)",
    fill: "url(#linear-gradient-sl)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M345.185,0h-3.458a.283.283,0,0,0-.24.136c-.735,1.212-6.114,10.087-7.707,12.655a1.987,1.987,0,0,0,2.391,1.535,2.159,2.159,0,0,0,1.558-1.227c.785-1.217,5.776-9.489,7.689-12.652A.289.289,0,0,0,345.185,0Z",
    transform: "translate(-249.52)",
    fill: "url(#linear-gradient-sl-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M303.124,61.461a2.612,2.612,0,0,0-1.714,1.351c-.664,1.027-3.034,4.93-3.842,6.26a.289.289,0,0,0,.232.447h3.458a.275.275,0,0,0,.237-.136c.467-.762,2.754-4.506,3.847-6.245a2.032,2.032,0,0,0-2.221-1.679Z",
    transform: "translate(-222.416 -45.921)",
    fill: "url(#linear-gradient-sl-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    transform: "translate(0 6.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M68.6,30.708c.7-4.319-.7-5.768-5.44-5.768-2.083,0-4.276.088-6.47.263-.263.023-.351.088-.374.308L53.73,41.894c-.066.285,0,.351.263.351h3.4c.263,0,.328-.066.4-.351l.9-5.768h2.7c4.758,0,6.536-1.053,7.215-5.417Zm-4.122.131c-.285,1.82-.944,2.259-3.049,2.259H59.17l.724-4.627h2.282c2.083,0,2.587.571,2.3,2.368Z",
    transform: "translate(-40.148 -24.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M114.412,24.94c-2.807,0-3.312.2-4.387,2.653l-6.185,14.3c-.088.242,0,.351.22.351h3.355c.2,0,.242-.109.351-.351l1.908-4.43h5.506l.5,4.43c.023.242.043.351.242.351h3.355a.312.312,0,0,0,.351-.351l-1.646-14.3C117.7,25.16,117.262,24.94,114.412,24.94Zm-3.289,9.211,2.325-5.483c.109-.285.174-.351.417-.351.285,0,.285.066.328.351l.636,5.483Z",
    transform: "translate(-77.6 -24.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M181.641,24.94c-2.083,0-4.276.088-6.47.263-.263.023-.351.088-.374.308L172.21,41.894c-.066.285,0,.351.263.351h3.4c.263,0,.328-.066.4-.351l.9-5.768h.871a2.142,2.142,0,0,1,1.984,1.179c.442,1.05,1.618,3.943,1.944,4.771a.3.3,0,0,0,.285.169h3.7c.192,0,.326-.149.265-.3-.4-1.025-1.452-3.643-1.893-4.637a2.9,2.9,0,0,0-2.065-1.411,5.4,5.4,0,0,0,4.827-5.185c.52-4.347-.7-5.768-5.44-5.768Zm1.315,5.9c-.285,1.82-.944,2.259-3.049,2.259h-2.259l.725-4.627h2.282c2.083,0,2.587.571,2.3,2.368Z",
    transform: "translate(-128.719 -24.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M251.718,24.988l-4.12-.048a.589.589,0,0,0-.411.235c-.934,1.159-4.236,5.215-5.453,6.69a5.637,5.637,0,0,1-.565.6l.005-.043,1.1-7c.023-.22-.066-.351-.285-.351h-3.4a.352.352,0,0,0-.374.351L235.6,41.891c-.023.242.066.351.285.351h3.4a.339.339,0,0,0,.374-.351l1.252-7.765a3.392,3.392,0,0,1,.783,1.04c.765,1.507,2.832,5.65,3.413,6.836a.406.406,0,0,0,.336.242h4.072c.192,0,.278-.215.172-.432-.719-1.467-2.572-5.22-3.32-6.647a4.044,4.044,0,0,0-1.777-1.749,6.085,6.085,0,0,0,1.871-1.5c1.171-1.393,4.145-5.069,5.3-6.505.172-.212.146-.424-.048-.427Z",
    transform: "translate(-176.122 -24.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M313.053,32.5a2.286,2.286,0,0,1-.1-.252h0c-.02-.05-.043-.1-.061-.151-.01-.035-.025-.081-.035-.121-.356-1.194-1.537-5.622-1.807-6.634a.274.274,0,0,0-.265-.21l-3.615-.01a.3.3,0,0,0-.275.376c.336,1.272,1.421,5.385,1.742,6.44a1.936,1.936,0,0,0,1.815,1.325H313.7a2.166,2.166,0,0,1-.646-.762Z",
    transform: "translate(-229.412 -25.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M17.894,26.012a36,36,0,0,0-3.814-.252,10.515,10.515,0,0,0-5.089,1.1c-.091.048-.179.1-.263.149a3.582,3.582,0,0,0-1.6,2.434l-.1.677-.157,1.091h0l-.023.151a3.9,3.9,0,0,1,1.8-1.106l.045-.015c2.656-.851,4.44-.778,8.664-.305a.359.359,0,0,0,.394-.3l.459-3.216a.36.36,0,0,0-.316-.4Z",
    transform: "translate(-5.12 -25.553)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M9.572,72.153a.455.455,0,0,0-.053.02c-2.653.851-4.44.778-8.666.305a.359.359,0,0,0-.394.3C.353,73.514.106,75.246,0,76a.357.357,0,0,0,.316.4c3.994.434,6.5.4,8.9-.843.091-.048.179-.1.263-.151a3.59,3.59,0,0,0,1.6-2.434l.081-.563.114-.8h0l.081-.563a3.866,3.866,0,0,1-1.79,1.1Z",
    transform: "translate(0.004 -59.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M335.126,69.005c-.336-1.272-1.421-5.385-1.742-6.44a1.936,1.936,0,0,0-1.815-1.325H328.32a2.153,2.153,0,0,1,.646.765,2.291,2.291,0,0,1,.1.252h0c.02.05.043.1.061.151.01.035.025.081.035.121.356,1.194,1.537,5.622,1.807,6.634a.274.274,0,0,0,.265.21l3.615.01a.3.3,0,0,0,.275-.376Z",
    transform: "translate(-245.439 -52.076)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoSmall);
export default __webpack_public_path__ + "static/media/MainLogoSmall.175e912e2a5a927e042009b38df497cb.svg";
export { ForwardRef as ReactComponent };